import CategoryManagement from './CategoryManagement';

export default CategoryManagement;
